import { createContext } from "react";
import {
  CollectionBookContextValue,
  CollectionDeleteContextValue,
  CollectionHandlerContextValue,
  CollectionIndexContextValue,
} from "./";

/* ===========================================================================
 * COLLECTIONS CONTEXTS DEFINITION
 * This file centralizes the creation of React Contexts for the Collection
 * module, ensuring a unified state management strategy across the application.
 * =========================================================================== */

/**
 * Context for managing the main Collection Index page state.
 * Includes modal configurations and general listing callbacks.
 */
export const CollectionIndexContext = createContext<
  CollectionIndexContextValue | undefined
>(undefined);

/**
 * Context for single Collection operations (CRUD).
 * Handles the state and logic for creating, editing, and viewing collection details.
 */
export const CollectionHandlerContext = createContext<
  CollectionHandlerContextValue | undefined
>(undefined);

/**
 * Context for batch deletion operations.
 * Manages the state and execution flow for deleting multiple collections at once.
 */
export const CollectionDeleteContext = createContext<
  CollectionDeleteContextValue | undefined
>(undefined);

/**
 * Context for batch booking operations.
 * Manages the state and execution flow for booking multiple collections at once.
 */
export const CollectionBookContext = createContext<
  CollectionBookContextValue | undefined
>(undefined);
